module.exports = __webpack_public_path__ + "img/wine.f0ce7c65.svg";